import { environment } from '../environments/environment';
import { LogLevel } from 'angular-auth-oidc-client';

export const AuthConfig = {
  authority: environment.discoveryUrl,
  scope: 'openid profile offline_access',
  forbiddenRoute: '/forbidden',
  unauthorizedRoute: '/unauthorized',
  postLoginRoute: environment.baseUrl + '/aanvragen',
  redirectUrl: environment.baseUrl + '/authorize',
  postLogoutRedirectUri: window.location.origin,
  clientId: environment.helloIdClientId,
  ignoreNonceAfterRefresh: true,
  logLevel: LogLevel.None,
  historyCleanupOff: true,
  responseType: 'code',
  useRefreshToken: true,
  autoUserInfo: false,
  silentRenew: true,
  secureRoutes: ['https://partou-employee.test.m4mapp.com/', 'https://api.medewerker-app.partou.nl'],
};
